"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Files = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 14,
  viewBox: "0 0 16 14"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M2.5 4.065a.728.728 0 0 0-.722.733c0 .219.174.396.389.396h11.666a.392.392 0 0 0 .39-.396.728.728 0 0 0-.723-.733h-11zM1.056 0H4.95c.247 0 .486.088.676.249l.87.736c.11.093.248.144.391.144h8.056c.583 0 1.056.48 1.056 1.073v10.725C16 13.52 15.527 14 14.944 14H1.056C.472 14 0 13.52 0 12.927V1.073C0 .48.472 0 1.056 0z"
}));

var _default = Files;
exports.default = _default;